import React from 'react'
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import List from '../../list/list'
import ListExpandable from '../../list/list-expandable'
import Text from '../../form/form-text'
import Select from '../../form/form-select'

class ModuleListProgram extends React.Component {

    constructor(props){
        super(props)
        this.state = {
            data: this.props,
            disabled: this.props.disabled
        }

        this.types = ["Portrait", "Landscape"].map( t => ({id: t, value: t}) );
        this.pubPositions = [];
        ["Frame", "Top", "Bottom"].forEach( position => [1,2,3].forEach(num => this.pubPositions.push(position + num))  );
        this.pubPositions = this.pubPositions.map( t => ({id: t, value: t}) );
    }

    UNSAFE_componentWillReceiveProps(nextProps, nextState) {
        this.setState({disabled: nextProps.disabled})
    }

    render() {
        let { orderBy, count, appsOnly, elements, imageType, pub, title } = this.state.data;
        let { disabled } = this.state;

        return <div className="module-listProgram">

            <Text disabled={disabled} value={title} />
            <Select disabled={disabled} value={imageType} options={this.types} />
            <Select disabled={disabled} value={pub} options={this.pubPositions} />

            { !disabled && <ListExpandable collection={elements} template={ e => { }} /> }
            <List printable={!disabled} collection={elements} />

            {/*<Text disabled={disabled} value={appsOnly} />*/}
            {/*<Text disabled={disabled} value={count} />*/}
            {/*<Text disabled={disabled} value={orderBy} />*/}
        </div>;
    }
}

ModuleListProgram.propTypes = {
    onChange: PropTypes.func.isRequired,
    disabled: PropTypes.bool, // souhld be .isRequired,
    isCustom: PropTypes.bool, // souhld be .isRequired,
    title: PropTypes.string,
    imageType: PropTypes.string,
    pub: PropTypes.string,
    elements: PropTypes.string,

    orderBy: PropTypes.string,
    count: PropTypes.string,
    appsOnly: PropTypes.bool
}

export default ModuleListProgram;

